import { NoneToVoidFunction } from "./fasterdom";

type AnyFunction = (...args: any[]) => any;

const SAFE_EXEC_ENABLED = true;

type SafeExecOptions = {
  rescue?: (err: Error) => void;
  always?: NoneToVoidFunction;
  shouldIgnoreError?: boolean;
};

export default function safeExec<T extends AnyFunction>(
  cb: T,
  options?: SafeExecOptions
): ReturnType<T> | undefined {
  if (!SAFE_EXEC_ENABLED) {
    return cb();
  }

  const { rescue, always } = options ?? {};

  try {
    return cb();
  } catch (err: any) {
    rescue?.(err);
    return undefined;
  } finally {
    always?.();
  }
}
